import createReactComponent from '../createReactComponent';
export default createReactComponent('search-off', 'SearchOff', [["path",{"d":"M19 11.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-2.107 5.42 3.08 3.08M21 3 3 21","key":"svg-0"}]]);